import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import accountType from "@/types/account";


export default /*@__PURE__*/_defineComponent({
  __name: 'EditIcon',
  props: {
    account: {},
    employeeCode: {}
  },
  emits: ['openUpdateModal'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit
const props = __props;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('openUpdateModal', props.account, props.employeeCode))),
    class: "material-symbols-outlined"
  }, " edit_note "))
}
}

})